import { render, staticRenderFns } from "./PaymentHistoric.vue?vue&type=template&id=4b7bf31e"
import script from "./PaymentHistoric.vue?vue&type=script&lang=js"
export * from "./PaymentHistoric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports